import styled from '@emotion/styled'
import { SelectChangeEvent, Typography } from '@mui/material'
import { useState } from 'react'
import { CheckboxSelect, CheckboxSelectOption } from 'src/components/checkbox-select'
import { DateRangePicker } from 'src/components/date-range'
import { FlexColumn } from 'src/components/flex-containers'
import { Colors } from 'src/components/theme'

type Option = 'purchases' | 'sales'
const OPTIONS: CheckboxSelectOption<Option>[] = [
  {
    value: 'purchases',
    label: 'Purchases',
  },
  {
    value: 'sales',
    label: 'Sales',
  },
]

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const AcquisitionsOverviewFilters = () => {
  const [option, setOption] = useState<Option[]>(['purchases'])

  const handleChange = (event: SelectChangeEvent<Option[]>) => {
    const value = event.target.value as Option[]
    if (value.length === 0) {
      return
    }

    setOption(value)
  }
  return (
    <Wrapper>
      <FlexColumn gap={4}>
        <Typography variant="text1" color={Colors.textBlack}>
          Filter
        </Typography>
        <CheckboxSelect value={option} options={OPTIONS} style={{ width: 140 }} onChange={handleChange} />
      </FlexColumn>
      <DateRangePicker />
    </Wrapper>
  )
}
